export default __webpack_public_path__ + "static/media/Logoupdated.843d2119.png";